// Generated by ReScript, PLEASE EDIT WITH CARE


var estimate_card_text = "Get an estimate";

var estimate_card_subtext = "(takes ~2 mins)";

var section_services_text = "OUR SERVICES";

var section_offers_text = "OFFERS AT PORTER";

var home_page_title = "Porter | Mini trucks & bikes for delivery | Packers & Movers | Book and transport easily!";

var home_page_path = "/";

var home_page_description = "Porter offers commercial vehicles & bike for delivery services. We offer complete logistics solutions including Packers & Movers and Outstation services. Book to enjoy superfast deliveries.";

var home_page_footprint_text = "Marhaba Dubai! We're now live & ready to take care of all your logisitical needs.";

var testimonials_title = "SOME WORDS FROM OUR HAPPY CUSTOMERS!";

var ga_city_selector_action = "City Selection Dropdown/<Click>";

var ga_get_estimate_action = "Get Estimate Button Click/<Click>";

var ga_button_sticky_top_close_action = "Sticky Download - Top Close";

var ga_button_sticky_top_download_action = "Sticky Download - Top";

var ga_category_card_action = " Category Card Click";

var ga_service_card_action = "Service Card Click - ";

var ga_offer_card_action = "Offer Card Click";

var ga_estimate_category_card_action = "Estimate Card Click - ";

var ga_estimate_vertical_switch_action = "Change Category Switch /<Click>";

var ga_estimate_vertical_switch_category_action = "Change Category Switch from ";

var ga_hamburger_mobile_action = "Mobile Menu Migrated /<Click>";

var ga_read_article_action = "News Article Redirect";

var ga_header_link_action = "Header Link /Click<Redirect>";

var ga_header_specific_link_action = "Header Link Redirect";

var ga_footer_specific_link_action = "Footer Click - ";

var ga_header_hamburger_action = "Mobile Menu Overlay Close";

var ga_header_home_action = "Header Logo /<Click>";

var ga_page_landing = "fe_home_land";

var ga_get_estimate_action_v2 = "fe_home_getest_tap";

var category_param = "category";

var paymentSuccessEvent = "fe_pnm_booking_confirm_land";

var wave_icon = "https://nest-platform-assets.porter.in/section_header_wave_08fd2da149/section_header_wave_08fd2da149.svg";

var enterprise_card_title = "PORTER ENTERPRISE";

var enterprise_card_subtitle_number = "10000+";

var enterprise_card_subtitle_text = " Business Trust Us";

var enterprise_card_description = "Manage logistics needs of your business with Porter Enterprise";

var enterprise_card_cta_text = "Get in Touch";

var enterprise_href = "/enterprise";

var enterprise_lottie_click = "tap_on_visual_enterprise_section";

var enterprise_cta_click_b = "tap_primary_cta_pfe_section_var_B";

var delayValue = 500;

var ent_exp_var_a = "A";

var ent_exp_var_b = "B";

export {
  estimate_card_text ,
  estimate_card_subtext ,
  section_services_text ,
  section_offers_text ,
  home_page_title ,
  home_page_path ,
  home_page_description ,
  home_page_footprint_text ,
  testimonials_title ,
  ga_city_selector_action ,
  ga_get_estimate_action ,
  ga_button_sticky_top_close_action ,
  ga_button_sticky_top_download_action ,
  ga_category_card_action ,
  ga_service_card_action ,
  ga_offer_card_action ,
  ga_estimate_category_card_action ,
  ga_estimate_vertical_switch_action ,
  ga_estimate_vertical_switch_category_action ,
  ga_hamburger_mobile_action ,
  ga_read_article_action ,
  ga_header_link_action ,
  ga_header_specific_link_action ,
  ga_footer_specific_link_action ,
  ga_header_hamburger_action ,
  ga_header_home_action ,
  ga_page_landing ,
  ga_get_estimate_action_v2 ,
  category_param ,
  paymentSuccessEvent ,
  wave_icon ,
  enterprise_card_title ,
  enterprise_card_subtitle_number ,
  enterprise_card_subtitle_text ,
  enterprise_card_description ,
  enterprise_card_cta_text ,
  enterprise_href ,
  enterprise_lottie_click ,
  enterprise_cta_click_b ,
  delayValue ,
  ent_exp_var_a ,
  ent_exp_var_b ,
}
/* No side effect */
